// import React, { useEffect, useRef, useState } from 'react'
// import { Button, Card, CardBody, Col, Row } from 'reactstrap'
// import Chart from "react-apexcharts";
// import CompareDataChart from './Charts/CompareDataCharts/CompareDataChart';
// import { Filter } from 'react-feather';
// import { IoCheckmarkOutline } from 'react-icons/io5';
// import { RxReset } from 'react-icons/rx';
// import WeekMonthComparisonFilter from './Dates/DateFiltersForCompareData';
// import AreaService from '../../../../../api/areaService';

// const CompareDataComp = () => {

//     let dummyAlertCount = [
//         { time: `Helmet`, current_week: 40, last_week: 30 },
//         { time: "Vest", current_week: 10, last_week: 10 },
//         { time: "MMHE", current_week: 20, last_week: 12 },
//         { time: "E.Exit", current_week: 56, last_week: 22 },
//         { time: "M.Guard", current_week: 26, last_week: 12 },
//     ]

//     useEffect(()=>{
//         getAlertsCharts()
//     }, [])

//      async function getAlertsCharts() {
//         const payload = {
//               safety_area: [],
//               shift: [],
//               factory_id: JSON.parse(localStorage.getItem('userData')).factory?.id,
//               start_date:'',
//               end_date:'',
//               week: '',
//               month: '',
//             };
//         const res = await AreaService.getAlertsChart(payload);

//         const desiredOrder = [
//           "Emergency Exit",
//           "MMHE",
//           "Helmet",
//           "Vest",
//           "Machine Guard",
//         ];
//         let sortedData = res?.data?.totalAlertsChart?.sort((a, b) => {
//           return (
//             desiredOrder.indexOf(a?.category) - desiredOrder.indexOf(b?.category)
//           );
//         });
//     }


//     //filters functionalty
//     const [filterType, setFilterType] = useState('week');
//     const [week1, setWeek1] = useState('');
//     const [week2, setWeek2] = useState('');
//     const [month1, setMonth1] = useState('');
//     const [month2, setMonth2] = useState('');

//     console.log([{ "week1": week1 },
//     { "week2": week2 },
//     { "month1": month1 },
//     { "month2": month2 },
//     ])
//     useEffect(() => {
//         const isValid =
//             (filterType === 'week' && week1 && week2) ||
//             (filterType === 'month' && month1 && month2);
//         setShowButtons(isValid);
//     }, [filterType, week1, week2, month1, month2]);
//     useEffect(() => {
//         if (filterType === 'week') {
//             setMonth1('')
//             setMonth2('')
//         } else if (filterType === 'month') {
//             setWeek1('')
//             setWeek2('')
//         }
//     }, [filterType])

//     const [showButtons, setShowButtons] = useState(false);
//     const filterCardRef = useRef(null);
//     const filterButton = useRef(null);
//     const [showFilters, setShowFilters] = useState(false);
//     const style = {
//         minWidth: "182px",
//         width: "182px",
//         maxWidth: "182px",
//         height: "38px",
//         fontSize: 13,
//     };
//     useEffect(() => {
//         function handleClickOutside(event) {
//             if (
//                 filterCardRef.current &&
//                 filterButton.current &&
//                 !filterCardRef.current.contains(event.target) &&
//                 !filterButton.current.contains(event.target)
//             ) {
//                 setShowFilters(false);
//             }
//         }

//         // Add event listener to detect clicks outside of the element
//         document.addEventListener("mousedown", handleClickOutside);

//         // Cleanup listener on component unmount
//         return () => {
//             document.removeEventListener("mousedown", handleClickOutside);
//         };
//     }, [showFilters]);
//     async function ApplyFilter() { }
//     async function Reset() { }

//     //filters functionalty ended

//     const [alertCountChartData, setAlertCountChartData] = useState({
//         options: {
//             chart: {
//                 type: "bar",
//                 height: 350,
//                 stacked: false,
//                 toolbar: {
//                     show: true,
//                 },
//                 zoom: {
//                     enabled: false,
//                 },
//             },
//             responsive: [
//                 {
//                     breakpoint: 480,
//                     options: {
//                         chart: {
//                             height: 600,
//                         },
//                         plotOptions: {
//                             bar: {
//                                 columnWidth: "60px",
//                                 horizontal: true,
//                             },
//                         },
//                         yaxis: {
//                             labels: {
//                                 rotate: -45,
//                                 rorateAlways: true,
//                             },
//                         },
//                         grid: {
//                             show: true,
//                             borderColor: "#90A4AE",
//                             strokeDashArray: 0,
//                             position: "back",
//                             xaxis: {
//                                 lines: {
//                                     show: false,
//                                 },
//                             },
//                             yaxis: {
//                                 lines: {
//                                     show: true,
//                                 },
//                             },
//                         },
//                     },
//                 },
//             ],

//             plotOptions: {
//                 bar: {
//                     horizontal: false,
//                     borderRadius: 2,
//                     columnWidth: "60%",
//                     dataLabels: {
//                         position: "top",
//                     },
//                 },
//             },
//             xaxis: {
//                 show: true,
//                 categories: dummyAlertCount.map(item => item.time) || [],
//                 labels: {
//                     show: true,
//                     offsetY: 0,
//                 },

//             },
//             yaxis: {
//                 show: true,
//                 forceNiceScale: true,
//                 min: 0,
//                 max: undefined,
//                 labels: {
//                     show: true,
//                     trim: true,
//                     style: {
//                         fontSize: "12px",
//                         fontWeight: "semibold",
//                         cssClass: "apexcharts-xaxis-label",
//                     },
//                     offsetY: 0,
//                 },
//             },

//             colors: ['#ef4343', '#40a1ff'],
//             fill: {
//                 opacity: 1,
//             },

//             dataLabels: {
//                 enabled: false,
//                 offsetX: -1,
//                 offsetY: 1,
//                 style: {
//                     fontSize: "9px",
//                     fontFamily: "Proxima Nova, sans-serif",
//                     colors: ["white", "black"],
//                 },
//             },
//             tooltip: {
//                 enabled: true,
//                 intersect: false,
//                 shared: true,
//                 x: {
//                     show: true,
//                     // formatter: function (value) {
//                     //   return area ? "Camera: " + value : "Area: " + value;
//                     // },

//                 },
//                 y: {
//                     formatter: function (value) {
//                         return value;
//                     },
//                 },
//             },
//             grid: {
//                 show: true,
//                 borderColor: "#90A4AE",
//                 strokeDashArray: 0,
//                 position: "back",
//                 xaxis: {
//                     lines: {
//                         show: true,
//                     },
//                 },
//                 yaxis: {
//                     lines: {
//                         show: false,
//                     },
//                 },
//             },

//             legend: {
//                 show: true,
//                 position: "bottom",
//                 horizontalAlign: "center",
//                 fontSize: "13px",
//                 fontFamily: "Proxima Nova, sans-serif",
//                 fontWeight: 400,
//                 offsetX: 20,
//                 offsetY: 10,
//                 labels: {
//                     colors: "#757575",
//                 },
//                 // formatter: (w) => {
//                 //   return w?.toUpperCase();
//                 // },
//             },
//         },
//         series: [
//             {
//                 name: "Previous Week",
//                 // data:[],
//                 data: dummyAlertCount?.map((i) => i.current_week),
//             },
//             {
//                 name: "Current Week",
//                 // data: [],
//                 data: dummyAlertCount?.map((i) => i.last_week),
//             },
//         ],
//     });
//     return (
//         <>
//             <Row>
//                 <Col xs='6'>
//                     <h4>Comparision</h4>
//                 </Col>

//                 <Col className={` d-flex flex-wrap  justify-content-end`}
//                     xl="6"
//                     lg="6"
//                     md="6"
//                     sm="6"
//                     xs="12"
//                 >
//                     <div
//                         type="button"
//                         className={`d-flex justify-content-center filter-btnn  ${showFilters && "border_R"
//                             }`}
//                         ref={filterButton}
//                         onClick={() => setShowFilters(!showFilters)}
//                     >
//                         <p className="m-0" style={{ fontSize: "16px" }}>
//                             Filters
//                         </p>
//                         <span className="d-flex">
//                             <Filter color="#fff" size={16} className="ms-2 " />
//                         </span>
//                     </div>

//                     <div className="w-100 d-flex justify-content-end position-relative">
//                         {showFilters && (
//                             <div
//                                 style={{ zIndex: "2" }}
//                                 className={`d-flex align-items-center justify-content-end gap-2 py-3 filter-cardd shadow-sm`}
//                                 ref={filterCardRef}
//                             >
//                                 <div className="">

//                                     <WeekMonthComparisonFilter
//                                         filterType={filterType}
//                                         week1={week1}
//                                         week2={week2}
//                                         month1={month1}
//                                         month2={month2}
//                                         onTypeChange={(type) => setFilterType(type)}
//                                         onValueChange={(field, value) => {
//                                             if (field === 'week1') setWeek1(value);
//                                             else if (field === 'week2') setWeek2(value);
//                                             else if (field === 'month1') setMonth1(value);
//                                             else if (field === 'month2') setMonth2(value);
//                                         }}
//                                     />
//                                     {showButtons && (
//                                         <>
//                                             <Button
//                                                 style={{ ...style, justifySelf: 'center' }}
//                                                 className={`mx-2 p-0 rounded-3 shadow-sm d-flex align-items-center justify-content-evenly`}
//                                                 onClick={ApplyFilter}
//                                                 color=""
//                                             >
//                                                 <IoCheckmarkOutline
//                                                     style={{
//                                                         color: "#22c65e",
//                                                         fontSize: "20px",
//                                                         transform: "rotate(20deg)",
//                                                     }}
//                                                 />
//                                                 <p
//                                                     style={{ color: "#22c65e" }}
//                                                     className="m-0 p-0 "
//                                                 >
//                                                     {" "}
//                                                     Accept
//                                                 </p>
//                                             </Button>
//                                             <Button
//                                                 style={{ ...style, justifySelf: 'center' }}
//                                                 className={`mx-2 mt-3 rounded-3 shadow-sm d-flex align-items-center justify-content-evenly`}
//                                                 onClick={Reset}
//                                                 color=""
//                                             >
//                                                 <RxReset
//                                                     style={{
//                                                         color: "#4e74d4",
//                                                         fontSize: "20px",
//                                                         // transform: "rotate(20deg)",
//                                                     }}
//                                                 />
//                                                 <p
//                                                     style={{ color: "#4e74d4" }}
//                                                     className="m-0 p-0 "
//                                                 >
//                                                     {" "}
//                                                     Reset
//                                                 </p>
//                                             </Button>
//                                         </>
//                                     )}
//                                 </div>
//                             </div>
//                         )}
//                     </div>
//                 </Col>


//             </Row>


//             <Row>
//                 <Col xs='12' md='6' xl='4'>
//                     <Card
//                         className="target_card_compliance"
//                         style={{ marginBottom: 10 }}
//                     >
//                         <CardBody style={{ padding: "20px 20px 20px 0px" }}>
//                             <CompareDataChart />
//                         </CardBody>
//                     </Card>
//                 </Col>

//                 <Col xs='12' md='6' xl='8'>
//                     <Card
//                         className="target_card_alert"
//                         style={{ marginBottom: 10 }}
//                     >
//                         <CardBody style={{ padding: "20px 20px 20px 0px" }}>
//                             <Chart
//                                 options={alertCountChartData?.options}
//                                 series={alertCountChartData?.series}
//                                 type="bar"
//                                 height={alertCountChartData?.options?.chart?.height}
//                             />
//                         </CardBody>
//                     </Card>
//                 </Col>
//             </Row>



//         </>
//     )
// }

// export default CompareDataComp















// Updated CompareDataComp with double API calls, filterType persistence, loader and default values

import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, Card, CardBody, Col, Row, Spinner } from 'reactstrap';
import Chart from 'react-apexcharts';
import CompareDataChart from './Charts/CompareDataCharts/CompareDataChart';
import { Filter } from 'react-feather';
import { IoCheckmarkOutline } from 'react-icons/io5';
import { RxReset } from 'react-icons/rx';
import WeekMonthComparisonFilter from './Dates/DateFiltersForCompareData';
import AreaService from '../../../../../api/areaService';
import { getCurrentWeekWithYear } from '../../../../../utils/currentWeekWithYear';
import { getPreviousWeekFromWeekString, getPreviousWeekWithYear } from '../../../../../utils/getPreviousWeekWithYear';
import DynamicModulesContext from '../../../../../_helper/formData/DynamicModules/DynamicModulesContext';

const CompareDataComp = ({ filters }) => {
    const style = {
        minWidth: '170px',
        width: "170px",
        height: "38px",
        fontSize: 13,
    };
    const [filterType, setFilterType] = useState(localStorage.getItem('compare_filterType') || 'week');
    const [week1, setWeek1] = useState(localStorage.getItem('compare_week1') || getPreviousWeekFromWeekString(filters?.week) || getPreviousWeekWithYear());
    const [week2, setWeek2] = useState(localStorage.getItem('compare_week2') || filters?.week || getCurrentWeekWithYear());
    const [month1, setMonth1] = useState(localStorage.getItem('compare_month1'));
    const [month2, setMonth2] = useState(localStorage.getItem('compare_month2'));
    const [totalAlertSeries, setTotalAlertSeries] = useState([]);
    const [xaxisCategoriesModules, setXaxisCategoriesModules] = useState() 

    const [loading, setLoading] = useState(false);
    const [showButtons, setShowButtons] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const filterCardRef = useRef(null);
    const filterButton = useRef(null);
    const { AllActiveModules, setAllActiveModules } = useContext(DynamicModulesContext);

    const [alertCountChartData, setAlertCountChartData] = useState({
        series: [
            {
                name: "", // Empty name won't show in legend
                data: []  // Empty data array
            }
        ],
        options: {
            xaxis: { categories: [] },

            title: {
                text: 'Alerts by Module',
                align: 'center',
                style: {
                    fontSize: '14px',
                    fontWeight: '500',
                },
            },
            yaxis: {
                title: {
                    text: 'Alerts',
                    style: {
                        lineHeight: '2.5',
                        fontSize: '13px',
                        fontWeight: '100',
                        fontFamily: 'sans-serif',
                    },
                },
                labels: {
                    style: {
                        fontSize: '12px',
                    },
                },
                min: 0,
                forceNiceScale: true,
            },
            chart: {
                type: "bar",
                height: 350,
                stacked: false,
                toolbar: {
                    show: false,
                    tools: {
                        download: true,
                        selection: true,
                        zoom: true,
                        zoomin: true,
                        zoomout: true,
                        pan: true,
                        reset: true,
                    },
                },
                zoom: {
                    enabled: false,
                },
            },
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        chart: {
                            type: "bar",
                            height: 350,
                            stacked: false,
                            toolbar: {
                                show: true,
                            },
                            zoom: {
                                enabled: false,
                            },
                        },

                        plotOptions: {
                            bar: {
                                columnWidth: "60px",
                                horizontal: true,
                            },
                        },

                        grid: {
                            show: true,
                            borderColor: "#90A4AE",
                            strokeDashArray: 0,
                            position: "back",
                            xaxis: {
                                lines: {
                                    show: false,
                                },
                            },
                            yaxis: {
                                lines: {
                                    show: true,
                                },
                            },
                        },
                    },
                },
            ],

            plotOptions: {
                bar: {
                    horizontal: false,
                    borderRadius: 2,
                    columnWidth: "60%",
                    dataLabels: {
                        position: "top",
                    },
                },
            },
            // xaxis: {
            //     show: true,
            //     categories:[],
            //     labels: {
            //         show: true,
            //         offsetY: 0,
            //     },

            // },
            // yaxis: {
            //     show: true,
            //     forceNiceScale: true,
            //     min: 0,
            //     max: undefined,
            //     labels: {
            //         show: true,
            //         trim: true,
            //         style: {
            //             fontSize: "12px",
            //             fontWeight: "semibold",
            //             cssClass: "apexcharts-xaxis-label",
            //         },
            //         offsetY: 0,
            //     },
            // },
            colors: ['#0b76b7', '#41b2ef'],
            // colors: ['#ef4343', '#40a1ff'],
            fill: {
                opacity: 1,
            },

            dataLabels: {
                enabled: false,
                offsetX: -1,
                offsetY: 1,
                style: {
                    fontSize: "9px",
                    fontFamily: "Proxima Nova, sans-serif",
                    colors: ["white", "black"],
                },
            },
            tooltip: {
                enabled: true,
                intersect: false,
                shared: true,
                x: {
                    show: true,
                    // formatter: function (value) {
                    //   return area ? "Camera: " + value : "Area: " + value;
                    // },

                },
                y: {
                    formatter: function (value) {
                        return value;
                    },
                },
            },
            grid: {
                show: true,
                borderColor: "#90A4AE",
                strokeDashArray: 0,
                position: "back",
                xaxis: {
                    lines: {
                        show: true,
                    },
                },
                yaxis: {
                    lines: {
                        show: false,
                    },
                },
            },

            legend: {
                show: true,
                position: "bottom",
                horizontalAlign: "center",
                fontSize: "13px",
                fontFamily: "Proxima Nova, sans-serif",
                fontWeight: 400,
                offsetX: 20,
                offsetY: 10,
                labels: {
                    colors: "#757575",
                },
                // formatter: (w) => {
                //   return w?.toUpperCase();
                // },
            },
        },

    });
 


    useEffect(() => {
        const isValid =
            (filterType === 'week' && week1 && week2) ||
            (filterType === 'month' && month1 && month2);
        setShowButtons(isValid);
    }, [filterType, week1, week2, month1, month2]);

    useEffect(() => {
        if (filterType === 'week') {
            setMonth1('');
            setMonth2('');
        } else {
            setWeek1('');
            setWeek2('');
        }
    }, [filterType]);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [showFilters]);

    useEffect(() => {
        applyInitialFilters();
    }, []);

    const handleClickOutside = (event) => {
        if (
            filterCardRef.current &&
            filterButton.current &&
            !filterCardRef.current.contains(event.target) &&
            !filterButton.current.contains(event.target)
        ) {
            setShowFilters(false);
        }
    };

    const applyInitialFilters = async () => {
        if (filterType === 'week') {
            await fetchAlertData(week1, 'week', week1, 0);
            await fetchAlertData(week2, 'week', week2, 1);
        } else {
            await fetchAlertData(month1, 'month', month1, 0);
            await fetchAlertData(month2, 'month', month2, 1);
        }
    };

    const fetchAlertData = async (value, type, label, idx) => {
        setLoading(true);
        const payload = {
            safety_area: [],
            shift: [],
            factory_id: JSON.parse(localStorage.getItem('userData')).factory?.id,
            start_date: '',
            end_date: '',
            week: type === 'week' ? value : '',
            month: type === 'month' ? value : ''
        };
        setXaxisCategoriesModules(type === 'week' ? [week1, week2] : [month1, month2])
     const factoryID = JSON.parse(localStorage.getItem('userData')).factory.id

        try {
            const res = await AreaService.getAlertsChart(payload);
            const FactoryModules = AllActiveModules || []

            const filteredData = res?.data?.totalAlertsChart
            console.log('filteredData', filteredData)
            // const desiredOrder = ["Emergency Exit", "MMHE", "Helmet", "Vest"];
            const desiredOrder = FactoryModules
            // const sortedData = filteredData?.sort((a, b) => {
            //     return desiredOrder.indexOf(a?.category) - desiredOrder.indexOf(b?.category);
            // });
            const sortedData = filteredData?.filter(item => FactoryModules.includes(item.category))
            // const categories = sortedData.map(item => item.category);
            // const shortLabelMap = {
            //     "Emergency Exit": "E. Exit",
            //     "Helmet": "Helmet",
            //     "MMHE": "MMHE",
            //     "Vest": "Vest"
            // };

            const categories = sortedData.map(item => item.category);
            const values = sortedData.map(item => item.value);



            // Calculate total alerts
            const total = values.reduce((sum, val) => sum + val, 0);

            setAlertCountChartData(prev => ({
                ...prev,
                options: {
                    ...prev.options,
                    xaxis: { categories }
                },
                series: [
                    ...prev.series.filter(s => s.name && s.name !== ""), 
                    { name: label, data: values }
                ]
            }));

            setTotalAlertSeries(prev => {
                const updated = [...prev];
                updated[idx] = total;
                return updated;
            });
        } catch (error) {
            console.error("Error fetching alert data:", error);
        } finally {
            setLoading(false);
        }
    };

    const ApplyFilter = async () => {
        if (filterType === 'week') {
            localStorage.setItem('compare_week1', week1);
            localStorage.setItem('compare_week2', week2);
        } else {
            localStorage.setItem('compare_month1', month1);
            localStorage.setItem('compare_month2', month2);
        }
        localStorage.setItem('compare_filterType', filterType);
        // setAlertCountChartData({
        //     series: [], options: {
        //         xaxis: { categories: [] }
        //     }
        // });
        setAlertCountChartData({
            series: [
                {
                    name: "", // Empty name won't show in legend
                    data: []  // Empty data array
                }
            ],
            options: {
                xaxis: { categories: [] },

                title: {
                    text: 'Alerts by Module',
                    align: 'center',
                    style: {
                        fontSize: '14px',
                        fontWeight: '500',
                    },
                },
                yaxis: {
                    title: {
                        text: 'Alerts',
                        style: {
                            lineHeight: '2.5',
                            fontSize: '13px',
                            fontWeight: '100',
                            fontFamily: 'sans-serif',
                        },
                    },
                    labels: {
                        style: {
                            fontSize: '12px',
                        },
                    },
                },
                chart: {
                    type: "bar",
                    height: 350,
                    stacked: false,
                    toolbar: {
                        show: false,
                        tools: {
                            download: true,
                            selection: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true,
                        },
                    },
                    zoom: {
                        enabled: false,
                    },
                },
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: {
                                type: "bar",
                                height: 350,
                                stacked: false,
                                toolbar: {
                                    show: false,
                                    tools: {
                                        download: true,
                                        selection: true,
                                        zoom: true,
                                        zoomin: true,
                                        zoomout: true,
                                        pan: true,
                                        reset: true,
                                    },
                                },
                                zoom: {
                                    enabled: false,
                                },
                            },

                            plotOptions: {
                                bar: {
                                    columnWidth: "60px",
                                    horizontal: true,
                                },
                            },

                            grid: {
                                show: true,
                                borderColor: "#90A4AE",
                                strokeDashArray: 0,
                                position: "back",
                                xaxis: {
                                    lines: {
                                        show: false,
                                    },
                                },
                                yaxis: {
                                    lines: {
                                        show: true,
                                    },
                                },
                            },
                        },
                    },
                ],

                plotOptions: {
                    bar: {
                        horizontal: false,
                        borderRadius: 2,
                        columnWidth: "60%",
                        dataLabels: {
                            position: "top",
                        },
                    },
                },

                colors: ['#0b76b7', '#41b2ef'],
                fill: {
                    opacity: 1,
                },

                dataLabels: {
                    enabled: false,
                    offsetX: -1,
                    offsetY: 1,
                    style: {
                        fontSize: "9px",
                        fontFamily: "Proxima Nova, sans-serif",
                        colors: ["white", "black"],
                    },
                },
                tooltip: {
                    enabled: true,
                    intersect: false,
                    shared: true,
                    x: {
                        show: true,


                    },
                    y: {
                        formatter: function (value) {
                            return value;
                        },
                    },
                },
                grid: {
                    show: true,
                    borderColor: "#90A4AE",
                    strokeDashArray: 0,
                    position: "back",
                    xaxis: {
                        lines: {
                            show: true,
                        },
                    },
                    yaxis: {
                        lines: {
                            show: false,
                        },
                    },
                },

                legend: {
                    show: true,
                    position: "bottom",
                    horizontalAlign: "center",
                    fontSize: "13px",
                    fontFamily: "Proxima Nova, sans-serif",
                    fontWeight: 400,
                    offsetX: 20,
                    offsetY: 10,
                    labels: {
                        colors: "#757575",
                    },

                },
            },

        })
        await applyInitialFilters();
    };

    const Reset = async () => {
        localStorage.removeItem('compare_week1');
        localStorage.removeItem('compare_week2');
        localStorage.removeItem('compare_month1');
        localStorage.removeItem('compare_month2');
        localStorage.removeItem('compare_filterType');
        setFilterType('week');
        setWeek1('');
        setWeek2('');
        setMonth1('');
        setMonth2('');
        // setAlertCountChartData({ series: [], options: { xaxis: { categories: [] } } });
        setAlertCountChartData({
            series: [
                {
                    name: "", // Empty name won't show in legend
                    data: []  // Empty data array
                }
            ],
            options: {
                xaxis: { categories: [] },

                title: {
                    text: 'Alerts by Module',
                    align: 'center',
                    style: {
                        fontSize: '14px',
                        fontWeight: '500',
                    },
                },
                yaxis: {
                    title: {
                        text: 'Alerts',
                        style: {
                            lineHeight: '2.5',
                            fontSize: '13px',
                            fontWeight: '100',
                            fontFamily: 'sans-serif',
                        },
                    },
                    labels: {
                        style: {
                            fontSize: '12px',
                        },
                    },
                },
                chart: {
                    type: "bar",
                    height: 350,
                    stacked: false,
                    toolbar: {
            show: false,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true,
            },
          },
                    zoom: {
                        enabled: false,
                    },
                },
            }
        })
        await applyInitialFilters();
    };

    return (
        <>
            <Row>
                <Col xs="6">
                    <h4>Comparison</h4>
                    <div><span className='f-light'>Comparing {filterType === 'week' ? week1 + " - " + week2 : month1 + " - " + month2} </span></div>
                </Col>

                <Col className="d-flex flex-wrap justify-content-end" xl="6">
                    <div
                        type="button"
                        className={`d-flex justify-content-center filter-btnn ${showFilters && 'border_R'}`}
                        ref={filterButton}
                        onClick={() => setShowFilters(!showFilters)}
                    >
                        <p className="m-0" style={{ fontSize: '16px' }}>Filters</p>
                        <span className="d-flex"><Filter color="#fff" size={16} className="ms-2" /></span>
                    </div>
                    <div className="w-100 d-flex justify-content-end position-relative">
                        {showFilters && (
                            <div style={{ zIndex: '2', top: '-7px' }} className="d-flex flex-wrap align-items-center justify-content-center py-3 px-3 filter-cardd shadow-sm" ref={filterCardRef}>
                                <WeekMonthComparisonFilter
                                    filterType={filterType}
                                    week1={week1}
                                    week2={week2}
                                    month1={month1}
                                    month2={month2}
                                    onTypeChange={(type) => setFilterType(type)}
                                    onValueChange={(field, value) => {
                                        if (field === 'week1') setWeek1(value);
                                        if (field === 'week2') setWeek2(value);
                                        if (field === 'month1') setMonth1(value);
                                        if (field === 'month2') setMonth2(value);
                                    }}
                                />
                                {showButtons && (
                                    <>

                                        <Button
                                            style={{ ...style, justifySelf: 'center' }}
                                            className={`mx-2 mt-3 p-0 rounded-3 shadow-sm d-flex align-items-center justify-content-center gap-2`}
                                            onClick={ApplyFilter}
                                            color=""
                                        >
                                            <IoCheckmarkOutline
                                                style={{
                                                    color: "#22c65e",
                                                    fontSize: "20px",
                                                    transform: "rotate(20deg)",
                                                }}
                                            />
                                            <p
                                                style={{ color: "#22c65e" }}
                                                className="m-0 p-0 "
                                            >
                                                {" "}
                                                Accept
                                            </p>
                                        </Button>
                                        {/* <Button
                                            style={{ ...style, justifySelf: 'center' }}
                                            className={`mx-2 mt-3 rounded-3 shadow-sm d-flex align-items-center justify-content-evenly`}
                                            onClick={Reset}
                                            color=""
                                        >
                                            <RxReset
                                                style={{
                                                    color: "#4e74d4",
                                                    fontSize: "20px",
                                                    transform: "rotate(20deg)",
                                                }}
                                            />
                                            <p
                                                style={{ color: "#4e74d4" }}
                                                className="m-0 p-0 "
                                            >
                                                {" "}
                                                Reset
                                            </p>
                                        </Button> */}

                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </Col>
            </Row>
            {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '350px' }}>
                    <Spinner color="primary" />
                </div>
            ) : (
                <Row className='pb-3'>
                    <Col xs="12" md="6" xl="4">
                        <Card className="target_card_compliance" style={{ marginBottom: 10 }}>
                            <CardBody style={{ padding: '20px 20px 20px 0px' }}>
                                <CompareDataChart
                                    totalAlertSeries={totalAlertSeries}
                                    xaxisCategoriesModules={xaxisCategoriesModules}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                    <Col xs="12" md="6" xl="8">
                        <Card className="target_card_alert" style={{ marginBottom: 10 }}>
                            <CardBody style={{ padding: '20px 20px 20px 0px' }}>
                                {loading ? (
                                    <div className="d-flex justify-content-center align-items-center" style={{ height: '350px' }}>
                                        <Spinner color="primary" />
                                    </div>
                                ) : (
                                    <Chart
                                        options={alertCountChartData?.options}
                                        series={alertCountChartData?.series || []}
                                        type="bar"
                                        height={alertCountChartData?.options?.chart?.height || 350}
                                    />
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            )}

        </>
    );
};

export default CompareDataComp;

